import { useState, useEffect } from 'react';

/**
 * Recording State Manager - Maintains a global record of which assets are being recorded
 *
 */

type RecordedAssetsState = {
    [assetId: string]: boolean;
};

let recordedAssets: RecordedAssetsState = {};
const listeners: Array<() => void> = [];

const notifyListeners = () => {
    listeners.forEach((listener) => listener());
};

export const useRecordingStateManager = () => {
    const [, setForceUpdate] = useState({});

    useEffect(() => {
        const forceUpdate = () => setForceUpdate({});
        listeners.push(forceUpdate);

        return () => {
            const index = listeners.indexOf(forceUpdate);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        };
    }, []);

    const setIsCurrentlyRecording = (assetId: string, isRecorded: boolean) => {
        recordedAssets = { ...recordedAssets, [assetId]: isRecorded };
        notifyListeners();
    };

    const isCurrentlyRecording = (assetId: string): boolean => !!recordedAssets[assetId];

    const clearAllRecordings = () => {
        recordedAssets = {};
        notifyListeners();
    };

    return {
        setIsCurrentlyRecording,
        isCurrentlyRecording,
        clearAllRecordings,
    };
};
